<template>
  <v-btn
    dark
    depressed
    type="submit"
    x-large
    :style="`background-image: ${gradient}`"
    class="register-button mb-4"
    :to="to ? to : ''"
    :disabled="disabled"
  >
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  props: {
    gradient: String,
    to: Object,
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
